import React from 'react';
import moment from 'moment';
import { SendOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Button, Modal, Tooltip } from 'antd';
import { CLOSE_SEND_TO_WHATSAPP_MODAL, OPEN_SEND_TO_WHATSAPP_MODAL } from '../store/types';

export const isInvalidQuestion = {
  HEADER: true,
  IMAGE: true,
  VIDEO: true,
  SECTION: true,
};

export function formatTableHeaders(
  questions,
  responseJumpType,
  t,
  dispatch,
  openSendToWhatsAppModal,
) {
  /**
   * @type {import('antd').TableColumnsType<any>}
   */
  const headers = questions
    .filter((question) => !isInvalidQuestion[question.type])
    .reduce((acc, question) => {
      /**
       * @type {import('antd').TableColumnType<any>}
       */
      const config = {
        title: question.label,
        key: question.questionId,
        dataIndex: question.questionId,
        ellipsis: true,
        render: (val) => (val ? val.toString() : val),
      };
      if (question.type === 'FILE') {
        // eslint-disable-next-line react/display-name
        config.render = (val) => {
          return val ? (
            <a
              href={`https://files.whatsform.com/${val}`}
              rel="noreferrer"
              target="_blank"
              style={{ color: 'reset', textDecoration: 'underline' }}
            >
              Download file
            </a>
          ) : (
            val
          );
        };
      }

      if (question.type === 'PHONE') {
        // eslint-disable-next-line react/display-name
        config.render = (val) => {
          return val ? (
            <a
              href={`https://api.whatsapp.com/send?phone=${val}`}
              rel="noreferrer"
              target="_blank"
              style={{ color: 'reset', textDecoration: 'underline' }}
            >
              {`+${val}`}
            </a>
          ) : (
            val
          );
        };
      }

      if (question.type === 'EMAIL') {
        // eslint-disable-next-line react/display-name
        config.render = (val) => {
          return val ? (
            <a
              href={`mailto:${val}`}
              rel="noreferrer"
              target="_blank"
              style={{ color: 'reset', textDecoration: 'underline' }}
            >
              {val}
            </a>
          ) : (
            val
          );
        };
      }

      acc.push(config);

      if (question.type === 'PAYMENT') {
        acc.push({
          title: t('responses.referenceNo'),
          key: 'payment_reference',
          dataIndex: 'payment_reference',
          ellipsis: true,
          width: 100,
          render: (val, record) => {
            const paymentMethod = record[config.key];
            if (paymentMethod === 'paypal') {
              return (
                <a
                  href={`https://www.paypal.com/invoice/payerView/details/${val}`}
                  rel="noreferrer"
                  target="_blank"
                  style={{ color: 'reset', textDecoration: 'underline' }}
                >
                  {val}
                </a>
              );
            }
            if (paymentMethod === 'stripe') {
              return (
                <a
                  href={`https://dashboard.stripe.com/payments/${val}`}
                  rel="noreferrer"
                  target="_blank"
                  style={{ color: 'reset', textDecoration: 'underline' }}
                >
                  {val}
                </a>
              );
            }
            if (paymentMethod === 'razorpay') {
              return (
                <a
                  href={`https://dashboard.razorpay.com/app/payments/${val}`}
                  rel="noreferrer"
                  target="_blank"
                  style={{ color: 'reset', textDecoration: 'underline' }}
                >
                  {val}
                </a>
              );
            }
            return val;
          },
        });
      }
      return acc;
    }, []);

  if (responseJumpType && responseJumpType !== 'default') {
    headers.push({
      title: t('responses.delivered-to'),
      key: 'delivered_to',
      dataIndex: 'delivered_to',
      width: 150,
    });
  }

  headers.unshift({
    title: t('responses.time'),
    key: 'response_time',
    dataIndex: 'response_time',
    ellipsis: true,
    width: 230,
  });

  headers.unshift({
    title: t('responses.response-number'),
    key: 'response_number',
    dataIndex: 'response_number',
    render: function Render(val, record) {
      return (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {val}
          <Tooltip title={t('responses.send-to-whatsapp')} placement="right">
            <Button
              type="text"
              className="send-to-whatsapp"
              shape="circle"
              icon={<WhatsAppOutlined style={{ color: '#2ab200' }} />}
              onClick={() => dispatch({ type: OPEN_SEND_TO_WHATSAPP_MODAL, payload: record.key })}
            />
          </Tooltip>
        </span>
      );
    },
    width: 100,
  });

  return headers;
}

export function formatTableRows(questions, responses, responseJumpType) {
  const questionType = {};
  questions.forEach((question) => {
    questionType[question.questionId] = question.type;
  });
  const rows = responses.map(
    ({ responses: items, _id, createdAt, deliveredTo, responseNumber }) => {
      const row = {};
      items.forEach((item) => {
        row[item.questionId] = item.answer;
        if (item['paymentReferenceNo']) {
          row['payment_reference'] = item['paymentReferenceNo'];
        }
      });
      row['key'] = _id;
      row['response_time'] = moment(createdAt).format('llll');
      row['response_number'] = responseNumber ? `#${responseNumber}` : '';

      if (responseJumpType && responseJumpType !== 'default')
        row['delivered_to'] = deliveredTo ? `+${deliveredTo}` : '';

      return row;
    },
  );

  return rows;
}
